import { Stack, Typography } from "@mui/material";

interface Props {
  text: string;
  textAppend?: string;
  description?: string;
}

const SectionTitle = ({ text, textAppend, description }: Props) => (
  <Stack spacing={1}>
    <Typography variant="subtitle1">
      {text}
      {textAppend && (
        <Typography component="span" variant="subtitle1" color="textSecondary">
          &nbsp;{textAppend}
        </Typography>
      )}
    </Typography>
    {description && <Typography color="textSecondary">{description}</Typography>}
  </Stack>
);

export default SectionTitle;
